import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll position on every route change.
 *
 * The public site uses Lenis smooth-scroll, which intercepts window.scrollTo.
 * Calling window.scrollTo alone can leave the page stuck at its previous
 * scroll offset after a navigation. We route through the live Lenis instance
 * (exposed as `window.__lenis`) when it exists, and fall back to native scroll
 * on the admin shell where Lenis is not initialized.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const lenis = window.__lenis;
        if (lenis && typeof lenis.scrollTo === 'function') {
          lenis.scrollTo(el, { immediate: false });
        } else {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
    }
    const lenis = window.__lenis;
    if (lenis && typeof lenis.scrollTo === 'function') {
      lenis.scrollTo(0, { immediate: true, force: true });
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
